import React from 'react';
import { Box } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { Navigation } from '@/components/Layout/Navigation';
import { Footer } from '@/components/Layout/Footer';
import {
  HeroSection,
  SegmentedSearchBar,
  FeaturedStaysSection,
  HowItWorksSection,
  StatsStrip,
  HostCtaSection,
} from '@/components/Home';

export default function Home() {
  const navigate = useNavigate();

  const handleSearch = (params: {
    location?: string;
    checkIn?: string;
    checkOut?: string;
    guests?: number;
  }): void => {
    const query = new URLSearchParams();
    if (params.location) query.set('location', params.location);
    if (params.checkIn) query.set('checkIn', params.checkIn);
    if (params.checkOut) query.set('checkOut', params.checkOut);
    if (params.guests) query.set('guests', params.guests.toString());
    navigate(`/search?${query.toString()}`);
  };

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', minHeight: '100vh' }}>
      <Navigation />
      {/* Spacer for fixed AppBar */}
      <Box sx={{ height: 64 }} />

      <HeroSection>
        <SegmentedSearchBar onSearch={handleSearch} />
      </HeroSection>

      <FeaturedStaysSection />
      <HowItWorksSection />
      <StatsStrip />
      <HostCtaSection />

      <Footer />
    </Box>
  );
}
